import {
  Component, ElementRef,
  inject, viewChild, ViewChild
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import {
  SidebarComponent,
  SidebarLink,
} from 'src/app/common/internal-sidebar/internal-sidebar.component';
import { HeaderComponent } from '../../../common/templates/header/header.component';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { PreviewImageComponent } from "src/app/common/preview-image/preview-image.component";
import { PreviewImageService } from 'src/app/services/Image-preview/preview-image-service.service';

@Component({
  selector: 'ts-template',
  imports: [
    SidebarComponent,
    RouterOutlet,
    FooterComponent,
    ModalsComponent,
    HeaderComponent,
    ToastComponent,
    PreviewImageComponent,
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  // refs
  @ViewChild('modals', { static: true }) modalComponent!: ModalsComponent;
  @ViewChild('sidebar', { static: true, read: ElementRef })
  sidebar!: ElementRef;
  preview = viewChild.required<PreviewImageComponent>('preview');
  
  // injectablesc
  auth = inject(AuthService);
  modals = inject(ModalsService);
  previewService = inject(PreviewImageService);

  // data
  navLinks: SidebarLink[] = [];

  constructor() {
    const allowed = this.auth.isWithPrivilege();
    this.initSidebar(allowed);
  }

  ngOnInit() {
    this.modals.bindComponent(this.modalComponent);
    this.previewService.bindComponent(this.preview());
  }

  initSidebar(allowed: boolean) {
    this.navLinks = [
      {
        name: 'Dashboard',
        icon: 'bi-house',
        url: '/ts',
      },
      {
        name: 'Products',
        icon: 'bi-box',
        url: '/ts/products',
      },
      {
        name: 'Quotation',
        icon: 'bi-tags',
        url: '/ts/quotation',
      },
      ...(allowed ? [{
        name: 'Academe',
        icon: 'bi-mortarboard',
        url: '',
        children: [
          {
            name: 'Academe Tags',
            icon: 'bi-mortarboard',
            url: '/ts/academe/tags',
          },
          {
            name: 'Academe Brands',
            icon: 'bi-mortarboard',
            url: '/ts/academe/brands',
          },
        ],
      }] : []),
      {
        name: 'Industrial',
        icon: 'bi-wrench-adjustable-circle',
        url: '',
        children: [
          {
            name: 'Industrial Tags',
            icon: 'bi-wrench-adjustable-circle',
            url: '/ts/industrial/tags',
          },
          {
            name: 'Industrial Brands',
            icon: 'bi-wrench-adjustable-circle',
            url: '/ts/industrial/brands',
          },
        ],
      },
      {
        name: 'Inquiries',
        icon: 'bi-chat-left-text',
        url: '/ts/inquiries',
      },
      {
        name: 'Events',
        icon: 'bi-calendar-event',
        url: '/ts/events',
      },
    ];
  }
  showSidebar() {
    this.sidebar?.nativeElement.focus();
  }
}
